import { Component, Input } from '@angular/core';

@Component({
  selector: 'aas-time-value',
  templateUrl: './time-value.component.html'
})
export class TimeValueComponent {
  @Input() id: string;
  @Input() value: string;
}
